<div *ngIf="loadingspinner == true" class="spin"></div>

<fieldset [disabled]="loadingspinner == true" [ngClass]="{'disabled':loadingspinner == true}">

  <div class="d-flex flex-wrap" *ngIf="token">
    <div class="two-card common-padding add-money shadow">
      <button class="btn btn-primary" style="float: right;" (click)="Back()">Back</button>
      &nbsp;

      <div class="row no-gutters">
        <div class="col-md-12">
          <div class="row no-gutters">

            <p *ngIf="userorderdetailList===null || userorderdetailList ==undefined">
              <strong>Sorry!</strong> No Course found !!!.
            </p>
            <br />

            <div class="col-12 form-padding" *ngIf="userorderdetailList != null">


              <div class="container p-3 my-3 bg-dark text-white">
                <h1>{{name}}</h1>
                <p>{{description}}</p>
              </div>

              <div class="container p-2 my-2 bg-light text-black" *ngIf="userorderdetailList?.WhatLearn.length != 0">
                <h2>
                  What Learn
                </h2>
                <ul *ngFor="let x of userorderdetailList?.WhatLearn"><li> {{x.Text}}. </li></ul>
              </div>

              <div class="container p-2 my-2 bg-light text-black" *ngIf="otherDetailsrequirements===null || otherDetailsrequirements ==undefined">
                <h2>
                  Requirements
                </h2>
                <p>{{otherDetailsrequirements}}</p>
              </div>

              <div class="container p-2 my-2 bg-light text-black" *ngIf="otherDetailsdescription===null || otherDetailsdescription ==undefined">
                <h2>
                  Description
                </h2>
                <p>{{otherDetailsdescription}}</p>
              </div>

              <div class="container p-2 my-2 bg-light text-black" *ngIf="userorderdetailList?.CourseContent.length != 0">
                <h2>
                  Course Content
                </h2>
                <ul *ngFor="let x of userorderdetailList.CourseContent">
                  <li>
                    {{x.Name}}
                    <ul *ngFor="let x1 of x.SubCourseContent">

                      <li>
                        {{x1.Name}}

                      </li>
                    </ul>

                  </li>

                </ul>
              </div>

              <div class="container p-2 my-2 bg-light text-black">
                <img [src]="icon" style="    width: 310px;    float: right;" />
                <h2>
                  Course Price : <label> ₹ {{price}}</label>
                  <!--<button class="primary-btn" type="button" style="margin-top: 20px;background-color:#f44a4a;"
          (click)="apisubmgt();$event.preventDefault()">
    Buy
  </button>-->

                  <button class="primary-btn" type="button" style="margin-top: 20px;background-color:#f44a4a;"
                          (click)="addProductToCart();$event.preventDefault()">
                    Add To Cart
                  </button>

                  <!--<button class="primary-btn" type="button" style="margin-top: 20px;background-color:#f44a4a;"
          (click)="removeProductToCart();$event.preventDefault()">
    Remove To Cart
  </button>-->
                </h2>

              </div>
            </div>
          </div>
        </div>
        <!--<div class="col-12 mt-4">
          <div class="pay-detail text-center">
            <div class="icon_wrap">
              <i class="icon-payment_secure"></i>
            </div>
            <span class="ng-binding">Your payment details are secured</span>
          </div>
        </div>-->
      </div>
    </div>





  </div>

</fieldset>
